import { render } from "./InvestGoods.vue?vue&type=template&id=4e332e42&scoped=true"
import script from "./InvestGoods.vue?vue&type=script&lang=js"
export * from "./InvestGoods.vue?vue&type=script&lang=js"

import "./InvestGoods.vue?vue&type=style&index=0&id=4e332e42&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e332e42"]])

export default __exports__